import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const Faqs = ({ faqs }) => {
  return (
    <div className="flex justify-center lg:items-start items-center 2xl:px-16 xl:px-10 lg:px-8 md:px-5 px-0 w-full">
      <div>
        <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-heading capitalize py-8 w-full font-normal">
          FAQs
        </h2>

        <Box sx={{ width: "100%" }}>
          {faqs.map((faq, index) => (
            <Accordion
              key={index}
              elevation={0}
              disableGutters
              sx={{
                borderBottom: "1px solid #fafaf6a4",
                "&::before": { display: "none" },
                boxShadow: "none",
                backgroundColor: "transparent",
              }}
            >
              <AccordionSummary
                expandIcon={
                  <ArrowForwardIosIcon
                    sx={{ fontSize: 16, color: "white" }}
                  />
                }
                aria-controls={`panel${index}-content`}
                id={`panel${index}-header`}
                sx={{
                  paddingY: 3,
                  paddingX: 0,
                  "& .MuiAccordionSummary-content": {
                    margin: 0,
                  },
                }}
              >
                <h3 className=" font-heading xl:text-[20px] text-[18px] leading-[1.4em] text-[#f5f5f5] font-normal">
                  {faq.question}
                </h3>
              </AccordionSummary>

              <AccordionDetails sx={{ paddingX: 0, paddingBottom: 2 }}>
                <div className="text-[#cccccc] text-[16px]  font-robout">
                  {faq.answer}
                </div>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </div>
    </div>
  );
};

export default Faqs;